import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { TaskDomain } from 'features/dashboard'

export const simulatorSlice = createSlice({
  name: 'simulator',
  initialState: {
    task: null as TaskDomain | null,
    taskLines: [] as string[],
    resultsByLines: null as boolean[] | null,
    results: {
      time: null as null | number,
      symbolsPerMinute: null as null | number,
    },
    timerStatus: 'inactive' as 'inactive' | 'active' | 'finished',
    isCompleted: false,
  },
  reducers: {
    setTask(state, action: PayloadAction<TaskDomain>) {
      state.task = action.payload
    },
    setTaskLines(state, action: PayloadAction<string[]>) {
      state.taskLines = action.payload
    },
    checkCode(state, action: PayloadAction<string[]>) {
      state.resultsByLines = state.taskLines.map((line, index) => line === action.payload[index])
      if (state.resultsByLines.every(item => item === true)) {
        state.timerStatus = 'finished'
      }
    },
    startTask(state) {
      state.timerStatus = 'active'
    },
    setResults(state, action: PayloadAction<number>) {
      const symbolsQuantity = state.taskLines.reduce((acc, line) => {
        return (acc += line.trim().length)
      }, 0)

      state.results.time = action.payload
      state.results.symbolsPerMinute = Math.floor((symbolsQuantity * 60) / action.payload)
      state.isCompleted = true
    },
    resetSimulator(state) {
      state.resultsByLines = []
      state.isCompleted = false
      state.timerStatus = 'inactive'
    },
  },
})

export const { setTask, setTaskLines, checkCode, resetSimulator, startTask, setResults } =
  simulatorSlice.actions

export const simulatorReducer = simulatorSlice.reducer
